import React from "react";
import { SimpleDialog, SimpleDialogProps } from "../../components/SimpleDialog";
import SimulationFeedback from "./SimulationFeedback";

export type SimulationFeedbackDialogProps = Pick<
  SimpleDialogProps,
  "onClose" | "open"
>;
export const SimulationFeedbackDialog = ({
  onClose,
  open,
}: SimulationFeedbackDialogProps) => {
  return (
    <SimpleDialog
      titleText="Please provide feedback on your role play experience."
      maxWidth="sm"
      open={open}
      disableCloseOnClickOutside={false}
    >
      <SimulationFeedback />
    </SimpleDialog>
  );
};
